import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import pinia from "@shared/store";
import { setupVxeTable } from "@shared/plugins/vxe-table";
import { setupElementIcons } from "@shared/plugins/element-icons";
import { setupPermissionDirective } from "@shared/plugins/permission";
import "@shared/plugins/element-plus";
import { t } from "@shared/utils/i18n";

import "@shared/styles/index.scss";

const app = createApp(App);

app.config.globalProperties.t = t;

app.use(pinia);
app.use(router);
setupVxeTable(app);
setupElementIcons(app);
setupPermissionDirective(app);

app.mount("#app");
